(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.cmpInit === '1') return;
    var track = root.querySelector('[data-cmp-track]');
    var dotsWrap = root.querySelector('[data-cmp-dots]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.cmp-card'));
    if (!cards.length) return;
    root.dataset.cmpInit = '1';

    function contentLeft(el) {
      var tr = track.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      return (r.left - tr.left) + track.scrollLeft;
    }

    function scrollToCard(i) {
      var c = cards[i];
      if (!c) return;
      var target = contentLeft(c) - (track.clientWidth - c.clientWidth) / 2;
      track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    function activeIndex() {
      var tr = track.getBoundingClientRect();
      var ref = tr.left + track.clientWidth / 2;
      var best = 0, bd = Infinity;
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect();
        var x = r.left + r.width / 2;
        var d = Math.abs(x - ref);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      cards.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cmp-dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Go to column ' + (i + 1));
        b.addEventListener('click', function () { scrollToCard(i); });
        dotsWrap.appendChild(b);
      });
    }

    function update() {
      if (!dotsWrap) return;
      var idx = activeIndex();
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
    }

    buildDots();
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { window.requestAnimationFrame(update); });
  }

  function initAll() {
    document.querySelectorAll('[data-cmp-slider]').forEach(init);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-cmp-slider]');
    if (el) { el.dataset.cmpInit = ''; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(wrap) {
    if (!wrap || wrap.dataset.packInit === '1') return;
    var track = wrap.querySelector('[data-pack-track]');
    var dotsWrap = wrap.querySelector('[data-pack-dots]');
    var prev = wrap.querySelector('[data-pack-prev]');
    var next = wrap.querySelector('[data-pack-next]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.pack-card'));
    if (!cards.length) return;
    wrap.dataset.packInit = '1';

    function isCenter() { return window.matchMedia('(max-width: 749px)').matches; }

    function contentLeft(el) {
      var tr = track.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      return (r.left - tr.left) + track.scrollLeft;
    }

    function scrollToCard(i) {
      var card = cards[i];
      if (!card) return;
      var target = contentLeft(card);
      if (isCenter()) {
        target = target - (track.clientWidth - card.clientWidth) / 2;
      }
      track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    function activeIndex() {
      var tr = track.getBoundingClientRect();
      var refX = isCenter() ? (tr.left + track.clientWidth / 2) : (tr.left + 2);
      var best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect();
        var x = isCenter() ? (r.left + r.width / 2) : r.left;
        var d = Math.abs(x - refX);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      cards.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pack-dot';
        b.setAttribute('aria-label', 'Go to pack ' + (i + 1));
        b.addEventListener('click', function () { scrollToCard(i); });
        dotsWrap.appendChild(b);
      });
    }

    function update() {
      var idx = activeIndex();
      if (dotsWrap) {
        var dots = dotsWrap.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === idx);
        }
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 2);
    }

    function step(dir) {
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      track.scrollBy({ left: dir * (cards[0].clientWidth + gap), behavior: 'smooth' });
    }

    buildDots();
    update();
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { window.requestAnimationFrame(update); });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function initAll() {
    document.querySelectorAll('[data-pack-cards]').forEach(init);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-pack-cards]');
    if (el) { el.dataset.packInit = ''; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-banner-scroll]');
  if (!trigger) return;

  var href = trigger.getAttribute('href') || '';
  if (href.charAt(0) !== '#' || href.length < 2) return;

  var id = href.slice(1);
  var target =
    document.getElementById(id) ||
    document.getElementById('shopify-section-' + id) ||
    document.querySelector(href);

  if (!target) return;

  event.preventDefault();

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });

  if (!target.hasAttribute('tabindex')) {
    target.setAttribute('tabindex', '-1');
  }
  target.focus({ preventScroll: true });
}, false);

  } catch(e) { console.error(e); }
})();
})();
